import { removeDuplications } from 'AppSrc/core/utility-functions/array-fun';
import { VF_MODAL } from 'AppSrc/core/components/forms/form-base-components/v-f-modal';
import {
  INLINE_ERRORS,
  MODAL_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  RELATIONSHIP_TYPE,
  ADD_RELATIONSHIPS,
  CONFIGURATION_ITEM_WITH_UA,
  CONFIGURATION_ITEM, // importing here for all relationships type for ci defect
  PROJECT_CODE,
  INCIDENT_REFERENCE,
  AST_BUSINESSSERVICE,
  BMC_PHYSICALLOCATION,
  BMC_PERSON,
  NEW_PROJECT_CODE,
  BMC_BUSINESSSERVICE,
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';
import {
  RELATIONSHIPS_SUMMARY,
} from 'AppSrc/core/components/forms/form-base-components/summary-components/modal-summary/relationships-summary';
import {
  getFieldValueForParameters,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import {
  RT_PROJECT_CODE,
  RT_CONFIGURATION_ITEM,
  RT_INCIDENT,
  PROJECT_MOBILE,
  NON_PROJECT_MOBILE,
  FIX_REPAIR_MOBILE,
  configItemWithUAYes,
  // MOBILE,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  CHANGE_REASON,
} from 'AppSrc//core/components/forms/form-types/create-crq/section-four/section-four-constants';
import {
  CHANGE_DETAILS,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';

import { RelationshipsModal } from './relationships-modal';
import { OpenModalButton } from './relationships-open-modal';
import 'AppSrc/core/style/components/form/fields/add-relationships.css';



const fieldId = ADD_RELATIONSHIPS;

const atLeastOneConfigItem = 'at least one Configuration Item.';

const projectCodeMessage = `Your change reason is set to 'Project', please relate at least one Project Code and ${atLeastOneConfigItem}`;
const incidentMessage = `Your change reason is set to 'Fix/Repair', please relate at least one Incident and ${atLeastOneConfigItem}`;
const configurationItemMessage = `Your change reason is set to 'Non-project', please relate ${atLeastOneConfigItem}`;
const CIUnavailability = 'CI Unavailability is mandatory for service outage CRQs.';

const mandatoryRelationshipMessageMap = {
  [RT_PROJECT_CODE]: projectCodeMessage,
  [RT_INCIDENT]: incidentMessage,
  [RT_CONFIGURATION_ITEM]: configurationItemMessage,
  // [CI_UNAVAILABILITY]: CIUnavailability,
};

const mandatoryBasedOnChangeReasonMap = {
  [PROJECT_MOBILE]: [RT_PROJECT_CODE, RT_CONFIGURATION_ITEM],
  [FIX_REPAIR_MOBILE]: [RT_INCIDENT, RT_CONFIGURATION_ITEM],
  [NON_PROJECT_MOBILE]: [RT_CONFIGURATION_ITEM],
};

const adjustRelationshipMessages = (params = {}) => {
  const {
    messages,
    changeReasonValue,
  } = params;

  return messages.map((message) => {
    if (message !== configurationItemMessage) {
      return message;
    }

    if (changeReasonValue === PROJECT_MOBILE) {
      return projectCodeMessage;
    }

    if (changeReasonValue === FIX_REPAIR_MOBILE) {
      return incidentMessage;
    }

    return message;
  });
};


// checks for any relationships that are mandatory based on formData
const getMandatoryRelationships = (params) => {
  const {
    changeReasonValue,
  } = params;

  const mandatoryRelationships = [];


  const mandatoryBasedOnChangeReason = mandatoryBasedOnChangeReasonMap[changeReasonValue];

  if (mandatoryBasedOnChangeReason) {
    mandatoryRelationships.push(...mandatoryBasedOnChangeReason);
  }

  return mandatoryRelationships;

};

const ChecknewValues = (params) => {
  const {
    values,
  } = params;
  const fieldValues = values[fieldId];
  const newrelationshipValues = fieldValues.formSectionsByDisplayOrder.map((formSection) => {
    const actualRefernceItem = fieldValues.dataByFormSectionId[formSection].relationshipId;
    const actualRefernceIteme = fieldValues.dataByFormSectionId[formSection].sectionId;
    return actualRefernceItem === actualRefernceIteme ? true : false;
  });
  return newrelationshipValues;
};


const getCurrentRelationships = (params) => {
  const {
    values,
  } = params;
  const fieldValues = values[fieldId];
  // return fieldValues.formSectionsByDisplayOrder.map((formSection) => fieldValues.dataByFormSectionId[formSection].dataByFieldId[CONFIGURATION_ITEM].value.referenceType);
  const newrelationshipValues = fieldValues.formSectionsByDisplayOrder.map((formSection) => {
    const actualRefernceItem = fieldValues.dataByFormSectionId[formSection].dataByFieldId[RELATIONSHIP_TYPE].value;
    let NewReferenceItem = CONFIGURATION_ITEM;
    if (actualRefernceItem === RT_PROJECT_CODE) {
      NewReferenceItem = PROJECT_CODE;
    }
    if (actualRefernceItem === RT_INCIDENT) {
      NewReferenceItem = INCIDENT_REFERENCE;
    }
    // return fieldValues.dataByFormSectionId[formSection].dataByFieldId[NewReferenceItem].value.referenceType;
    return fieldValues.dataByFormSectionId[formSection].dataByFieldId[NewReferenceItem].value ? fieldValues.dataByFormSectionId[formSection].dataByFieldId[NewReferenceItem].value.referenceType : fieldValues.dataByFormSectionId[formSection].dataByFieldId[RELATIONSHIP_TYPE].value;
  });
  return newrelationshipValues;
};

const getCitRelationships = (params) => {
  const {
    values,
  } = params;
  const fieldValues = values[fieldId];
  const newrelationshipValues = fieldValues.formSectionsByDisplayOrder.map((formSection) => {
    if (fieldValues.dataByFormSectionId[formSection].dataByFieldId[CONFIGURATION_ITEM_WITH_UA]) {
      return fieldValues.dataByFormSectionId[formSection].dataByFieldId[CONFIGURATION_ITEM_WITH_UA].value;
    }
    return false;
  });
  return newrelationshipValues;
};
// Get Risk values from Formdata
// This might need one day-- new requirments change to for PBI Task:9751
// CI unavailability should only be mandatory if the risk question "Is a service outage required = yes".
// const getriskValue = (params) => {
//   console.log('relationsips+++', params.formData.dataByFormSectionId.CHANGE_QUESTIONS.dataByFieldId.service_outage_required.value[0]);
//   const returnRiskvalue = false;
//   if (params.formData.riskValue === 'Risk Level 3' || params.formData.riskValue === 'Risk Level 4') {
//     console.log('getriskValue++', params.formData.riskValue);
//     return true;
//   }
//   // return returnRiskvalue = params.formData.riskValue === 'Risk Level 3' || params.formData.riskValue === 'Risk Level 4' ? true : false;
//   console.log('getriskValue++', params.formData.riskValue);
//   return returnRiskvalue;
// };
// creates error messages for any mandatory relationships that do not exist
const getMandatoryRelationshipsMessages = (params = {}) => {
  const {
    formData,
    values,
  } = params;
  const mandatoryRelationshipMessages = [];

  const changeReasonValue = getFieldValueForParameters({
    formData,
    sectionId: CHANGE_DETAILS,
    fieldId: CHANGE_REASON,
  });

  // const mandatoryRelationships = getMandatoryRelationships({
  let mandatoryRelationships = getMandatoryRelationships({
    // this might one day need form data, for now it only depends on one field
    changeReasonValue,
  });

  const currentRelationships = getCurrentRelationships({
    values,
  });

  const latest = ChecknewValues({
    values,
  });
  const getOccurrence = latest.filter((v) => (v === true)).length;
  let Required = NEW_PROJECT_CODE;
  if (currentRelationships.length === getOccurrence) {
    Required = RT_PROJECT_CODE;
  }


  // const remove = ['AST:BusinessService', 'BMC_PHYSICALLOCATION', 'BMC_PERSON', 'VF.CUSTOM:VF_PROJECT33', 'BMC_BUSINESSSERVICE', 'HPD:Help Desk', 'AST:Project'];
  const remove = [AST_BUSINESSSERVICE, BMC_PHYSICALLOCATION, BMC_PERSON, NEW_PROJECT_CODE, BMC_BUSINESSSERVICE, RT_INCIDENT, RT_PROJECT_CODE];
  const getcurrentCitRelationships = getCitRelationships({
    values,
  }).filter((e) => e !== null);
  const findCiUnavaiblity = getcurrentCitRelationships.map((item) => {
    const items = item[0] === configItemWithUAYes ? true : false;
    return items;
  });
  // not required might be need one day refer ADO PBI:9751
  // const GetcurrentRiskValue = getriskValue({
  //   formData,
  // });
  // const checkCI = GetcurrentRiskValue ? findCiUnavaiblity.includes(true) : true;

  // isServiceOutageRequired flag - PBI Task:9751 Ci unavailability mandatory if service outage required=yes
  const isServiceOutageRequired = formData.dataByFormSectionId.CHANGE_QUESTIONS.dataByFieldId.service_outage_required.value[0] === 'Yes' ? true : false;
  const newCheckCI = isServiceOutageRequired ? findCiUnavaiblity.includes(true) : true;
  // const remove = ['AST:BusinessService', 'BMC_PHYSICALLOCATION', 'BMC_PERSON', 'VF.CUSTOM:VF_PROJECT33', 'BMC_BUSINESSSERVICE', 'HPD:Help Desk'];
  // const Required = 'VF.CUSTOM:VF_PROJECT33';
  // const IncidentCI = 'HPD:Help Desk';
  if (changeReasonValue === PROJECT_MOBILE) {
    const projectCI = currentRelationships.includes(Required);
    const otherCI = currentRelationships.filter((value) => !remove.includes(value));
    if (otherCI.length >= 1 && projectCI) {
      mandatoryRelationships = currentRelationships;
    }
  }
  if (changeReasonValue === NON_PROJECT_MOBILE) {
    const otherCI = currentRelationships.filter((value) => !remove.includes(value));
    if (otherCI.length >= 1) {
      mandatoryRelationships = currentRelationships;
    }
  }
  if (changeReasonValue === FIX_REPAIR_MOBILE) {
    const incidentCi = currentRelationships.includes(RT_INCIDENT);
    const otherCI = currentRelationships.filter((value) => !remove.includes(value));
    if (otherCI.length >= 1 && incidentCi) {
      mandatoryRelationships = currentRelationships;
    }
  }
  mandatoryRelationships.forEach((mandatoryRelationship) => {
    const hasMandatoryRelationship = currentRelationships.includes(mandatoryRelationship);
    if (hasMandatoryRelationship) {
      if (!newCheckCI) {
        mandatoryRelationshipMessages.push(CIUnavailability);
      }
      return null;
    }
    const message = mandatoryRelationshipMessageMap[mandatoryRelationship];
    if (!message) {
      console.error(`Unable provide proper message for mandatoryRelationship: ${mandatoryRelationship}`);
      // fallback to the relationship type's hardcoded value
      mandatoryRelationshipMessages.push(mandatoryRelationship);
      return null;
    }
    mandatoryRelationshipMessages.push(message, newCheckCI ? '' : CIUnavailability);
    return null;
  });

  // FN: 02/07/2020
  // We create the messages based on what the mandatory relationships are but there edge
  // cases where some relationship can be mandatory for different reasons. As such we have
  // to adjust the messages so they are correct
  const adjustedMessages = adjustRelationshipMessages({
    messages: mandatoryRelationshipMessages,
    changeReasonValue,
  });

  const messages = removeDuplications(adjustedMessages);
  return messages;
};




const validator = (params) => {
  const {
    values,
    field,
    formData,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();


  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_MODAL);

  // NOT IMPLEMENTED, JUST RETURNS AN ARRAY UNTIL #VTO-755
  const mandatoryWorkInformationItemTypeMessages = getMandatoryRelationshipsMessages({
    formData,
    values,
  });

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please add relationships' : null);
  errors[MODAL_ERRORS] = [
    ...errors[MODAL_ERRORS],
    ...mandatoryWorkInformationItemTypeMessages,
  ];

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = {
  formSectionsByDisplayOrder: [],
  dataByFormSectionId: {},
};


const vFParams = {
  // Component that fires a callback to open the modal
  OpenModalComponent: OpenModalButton,
  // The modal to open
  ModalSection: RelationshipsModal,
  // A summary section for the data entered in the modal
  modalSummaryType: RELATIONSHIPS_SUMMARY,
  onRowDeletionAlert: {
    alertTitle: 'Are you sure you want to delete this relationship?',
    alertText: 'Please note this will permanently delete this relationship and cannot be recovered.',
    falseText: 'No',
    trueText: 'Yes, delete',
  },
  onCancelAlert: {
    alertTitle: "Are you sure you don't want to save changes to this relationship?",
    falseText: 'No',
    trueText: 'Yes, exit without saving',
    trueButtonCols: 4,
  },
  modalErrorsTitle: 'Please make sure that all relevant impacted CIs are added',
  getModalOptionsOverwrite(params) {
    const {
      modalDisplayData,
      closeModal,
      openCancelAlert,
      openDeleteAlert,
    } = params;

    if (!modalDisplayData) {
      return null;
    }

    const {
      type,
    } = modalDisplayData;

    return {
      saveChanges: true,
      saveChangesTextForValues: (values) => {
        // if we are editing the save changes button should say 'update relationship
        if (type === 'edit') return 'Update relationship';
        // for a new relationship, the button should say 'Relate', or 'Relate with unavailability'
        // depending on the value of the with unavailability button
        const configItemWithUAValue = values && values[CONFIGURATION_ITEM_WITH_UA];
        const isWithUa = configItemWithUAValue && configItemWithUAValue[0] === configItemWithUAYes;
        return `Relate${isWithUa ? ' with unavailability' : ''}`;
      },
      cancel: type === 'edit' ? openCancelAlert : closeModal,
      deleteItem: type === 'edit' ? openDeleteAlert : null,
    };
  },
};

const relationshipsField = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_MODAL,
};

export { relationshipsField };
